// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3XKPY","tab":"ProcedureTabs_tab__1mlU_"};